module.exports = __webpack_public_path__ + "static/media/Complaint_Handling_Policy_FSA.c9ddd842.pdf";